"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Register = void 0;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var formik_1 = require("formik");
var react_router_1 = require("react-router");
var react_router_dom_1 = require("react-router-dom");
var semantic_ui_react_1 = require("semantic-ui-react");
var classnames_1 = __importDefault(require("classnames"));
var react_i18next_1 = require("react-i18next");
var registerSlice_1 = require("../../../../features/register/registerSlice");
var Copyright_1 = __importDefault(require("../../../../components/Copyright"));
var loginSlice_1 = require("../../../../features/login/loginSlice");
var registrationSchema_1 = __importDefault(require("../../../../schemas/registrationSchema"));
var CompanyAutocomplete_1 = __importDefault(require("../../../../components/CompanyAutocomplete"));
var Validation_1 = __importDefault(require("../../../../components/Validation"));
var AppSlogan_1 = __importDefault(require("../../AppSlogan"));
var BlInput_1 = __importDefault(require("../../../../components/FormComponents/BlInput"));
var Routes_1 = require("../../../../constants/Routes");
var Button_1 = __importDefault(require("../../../../components/Button"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var styles_module_scss_2 = __importDefault(require("../../styles.module.scss"));
var Register = function (_a) {
    var developers = _a.developers;
    var t = react_i18next_1.useTranslation('common').t;
    var dispatch = react_redux_1.useDispatch();
    var registrationLoading = react_redux_1.useSelector(registerSlice_1.selectRegistrationLoading);
    var history = react_router_1.useHistory();
    var getErrorClass = function (formik, fieldName) {
        return formik.touched[fieldName] && formik.errors[fieldName]
            ? 'has-errors'
            : '';
    };
    var onSubmit = function (values, actions) { return __awaiter(void 0, void 0, void 0, function () {
        var e_1, errors, _i, _a, _b, key, value;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, dispatch(registerSlice_1.registerUser(values))];
                case 1:
                    _c.sent();
                    history.push(Routes_1.Routes.Verify.path);
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _c.sent();
                    errors = {};
                    for (_i = 0, _a = Object.entries(e_1.response.data.errors); _i < _a.length; _i++) {
                        _b = _a[_i], key = _b[0], value = _b[1];
                        // TODO set value type
                        // @ts-ignore
                        errors[key] = t(value);
                    }
                    actions.setErrors(errors);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", { id: styles_module_scss_1.default.register_form, className: styles_module_scss_2.default.page },
        react_1.default.createElement(AppSlogan_1.default, { title: t('APP_SLOGAN.TITLE'), text: t('APP_SLOGAN.TEXT'), backgroundColor: "primary", backgroundType: "third" }),
        react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_2.default.form, styles_module_scss_1.default.right_content) },
            react_1.default.createElement("div", { className: styles_module_scss_2.default.content },
                react_1.default.createElement("div", { className: styles_module_scss_2.default.content_body },
                    react_1.default.createElement("h2", { className: styles_module_scss_2.default.title }, t('WELCOME')),
                    react_1.default.createElement("p", { className: styles_module_scss_2.default.sub_title }, t('SING_IN_TO_CONTINUE')),
                    react_1.default.createElement(formik_1.Formik, { initialValues: {
                            username: '',
                            email: '',
                            password: '',
                            isDeveloper: false,
                            developerName: '',
                            agree: false,
                        }, validationSchema: registrationSchema_1.default, onSubmit: function (values, actions) {
                            onSubmit(values, actions);
                        } }, function (formik) { return (react_1.default.createElement(formik_1.Form, { className: styles_module_scss_1.default.register_form, autoComplete: 'off', autoSave: 'off' },
                        react_1.default.createElement("div", { className: styles_module_scss_1.default.isDeveloper_checkbox },
                            react_1.default.createElement("div", { className: "form-row" },
                                react_1.default.createElement(semantic_ui_react_1.Checkbox, { id: "isDeveloper", label: t('register.IS_DEVELOPER'), checked: formik.values.isDeveloper, onChange: function () {
                                        formik.setFieldValue('isDeveloper', !formik.values
                                            .isDeveloper);
                                    } }))),
                        formik.values.isDeveloper && (react_1.default.createElement("div", { className: 'validation-form-group' },
                            react_1.default.createElement(Validation_1.default, { name: "developerName", formikProps: formik },
                                react_1.default.createElement("div", { className: "form-row" },
                                    react_1.default.createElement(CompanyAutocomplete_1.default, { source: developers, placeholder: t('register.COMPANY_NAME'), onChange: function (value) {
                                            formik.setFieldValue('developerName', value);
                                        }, value: formik.values
                                            .developerName, icon: "ic-building-type", rounded: true, required: true }))))),
                        react_1.default.createElement("div", { className: "validation-form-group" },
                            react_1.default.createElement(Validation_1.default, { name: "username", formikProps: formik },
                                react_1.default.createElement(BlInput_1.default, __assign({ className: "form-row", icon: "ic-username", type: "text", placeholder: t('FORM_ITEMS.NAME'), rounded: true, required: true }, formik.getFieldProps('username'))))),
                        react_1.default.createElement("div", { className: "validation-form-group" },
                            react_1.default.createElement(Validation_1.default, { name: "email", formikProps: formik },
                                react_1.default.createElement(BlInput_1.default, __assign({ className: "form-row", icon: "email", type: "text", placeholder: t('FORM_ITEMS.EMAIL'), rounded: true, required: true }, formik.getFieldProps('email'), { onChange: function (e) {
                                        formik.setFieldValue('email', e.target.value
                                            .toLowerCase()
                                            .trim());
                                    } })))),
                        react_1.default.createElement("div", { className: "validation-form-group" },
                            react_1.default.createElement(Validation_1.default, { name: "password", formikProps: formik },
                                react_1.default.createElement(BlInput_1.default, __assign({ className: "form-row", icon: "password", type: "password", placeholder: t('FORM_ITEMS.PASSWORD'), rounded: true, required: true, autoComplete: 'new-password' }, formik.getFieldProps('password'), { onChange: function (e) {
                                        formik.setFieldValue('password', e.target.value.trim());
                                    } })))),
                        react_1.default.createElement("div", { className: 'validation-form-group form-checkbox' },
                            react_1.default.createElement("div", { className: classnames_1.default('form-row', getErrorClass(formik, 'agree'), styles_module_scss_1.default.agree_checkbox) },
                                react_1.default.createElement(semantic_ui_react_1.Checkbox, { id: "agree", label: t('AGREE'), checked: formik.values.agree, onChange: formik.handleChange('agree') }),
                                react_1.default.createElement(react_router_dom_1.Link, { target: "_blank", to: Routes_1.Routes.TermsAndConditions
                                        .path }, t('TERMS_OF_USAGE'))),
                            react_1.default.createElement(formik_1.ErrorMessage, { name: "agree" }, function (msg) { return (react_1.default.createElement("span", { className: "error-message" }, msg)); })),
                        react_1.default.createElement(Button_1.default, { loading: registrationLoading, disabled: registrationLoading, type: "submit" }, t('FORM_ITEMS.SIGN_UP')))); }),
                    react_1.default.createElement("p", { className: styles_module_scss_1.default.sing_in },
                        t('ALREADY_REGISTERED'),
                        ' ',
                        react_1.default.createElement("a", { className: styles_module_scss_1.default.login, onClick: function () {
                                dispatch(loginSlice_1.openLoginFormModal({
                                    redirectAfterLogin: true,
                                }));
                            } },
                            ' ',
                            t('FORM_ITEMS.SIGN_IN')))),
                react_1.default.createElement("div", { className: styles_module_scss_2.default.footer },
                    react_1.default.createElement(Copyright_1.default, null))))));
};
exports.Register = Register;
exports.default = exports.Register;
